import { useState, useEffect, useRef } from 'react'

interface FloatInputProps {
  value: number | null
  onChange: (value: number | null) => void
  placeholder?: string
  disabled?: boolean
  className?: string
  allowEmpty?: boolean
}

export function FloatInput({
  value,
  onChange,
  placeholder = 'z.B. 0.25',
  disabled,
  className = '',
  allowEmpty = false,
}: FloatInputProps) {
  const [text, setText] = useState<string>(value === null ? '' : String(value))
  const focusedRef = useRef(false)

  useEffect(() => {
    if (!focusedRef.current) {
      setText(value === null ? '' : String(value))
    }
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value
    setText(raw)

    if (raw === '') {
      if (allowEmpty) onChange(null)
      return
    }

    const normalized = raw.replace(',', '.')
    const parsed = parseFloat(normalized)
    if (!isNaN(parsed)) {
      onChange(parsed)
    }
  }

  const handleBlur = () => {
    focusedRef.current = false
    const parsed = parseFloat(text.replace(',', '.'))
    if (text === '' || text === '.' || text === ',' || isNaN(parsed) || parsed !== value) {
      setText(value === null ? '' : String(value))
    }
  }

  return (
    <input
      type="text"
      inputMode="decimal"
      value={text}
      placeholder={placeholder}
      onChange={handleChange}
      onFocus={() => { focusedRef.current = true }}
      onBlur={handleBlur}
      disabled={disabled}
      className={className}
    />
  )
}
